export default "__VITE_ASSET__4edbab3a__"